import AuthManager from '../../../core/oidc';
import { useEffect } from 'react';
import InfoCard from '../../../components/info-card';
import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles({
    text: {
        display: 'block',
        textAlign: 'center',
        marginBottom: 25
    },
    cardActions: {
        display: 'flex',
        justifyContent: 'center'
    }
});

export default function Logout() {

    const classes = useStyles();
    useEffect(() => {
        const callback = () => {
            AuthManager.logout();
        };
        callback();
    }, []);

    return (
        <InfoCard>
            <h4 className={classes.text}>Çıkış yapılıyor...</h4>
        </InfoCard>
    );
}
